<script>
	const Vue = require('vue');
	const logger = require('utilities/logger');
	const optimizedResize = require('utilities/optimizedResize');

	module.exports = {
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				observer: null,
				lineHeight: 17,
				top: null,
				bottom: null,
				offsetTop: 0
			};
		},
		methods: {
			calculateContentLineHeight() {
				const contentEl = this.$el;
				let lineHeight = this.lineHeight;

				if (contentEl) {
					// Calculate line height for content
					let lineHeightStr = window.getComputedStyle(contentEl).lineHeight;

					if (lineHeightStr) {
						try {
							lineHeight = parseFloat(lineHeightStr.replace('px', ''));
						} catch (e) {
							logger.info('line-height parsing failed, defaulting to 17px');
						}
					}
				}
				this.lineHeight = lineHeight;
			},
			recalcSentenceFrameDimensions() {
				const contentEl = this.$el;

				if (contentEl) {
					this.calculateContentLineHeight();
				}

				logger.info('Recalc Sentence Frame', 'offsetTop', this.offsetTop);
				this.sentenceFrameTracking(); // update frame if needed
			},
			sentenceFrameTracking(event) {
				const contentEl = this.$el;
				const show = this.show;
				let mouseY = event && event.pageY ? event.pageY : 0;

				if (show && contentEl) {
					const contentRect = contentEl.getBoundingClientRect();
					const lineHeight = this.lineHeight;
					const scrollY = window.scrollY;

					// Compare element to mouse location for offset
					const height = contentRect.height;

					// convert mouse y coord from page scope to element scope
					mouseY -= contentRect.top;
					if (scrollY) {
						mouseY -= scrollY;
					}

					const linesToShow = 1.5; // Show linesToShow * lineHeight space in frame
					const frameSize = lineHeight * linesToShow;

					const bottomPx = height - Math.max(mouseY, frameSize) + frameSize * 0.75;
					let topPx = Math.max(mouseY, frameSize) + frameSize / 4;

					Vue.nextTick(() => {
						this.$refs.frameTop.style.bottom = bottomPx + 'px';
						this.$refs.frameBottom.style.top = topPx + 'px';
					});
				}
			}
		},
		mounted() {
			const observer = new MutationObserver(() => {
				Vue.nextTick(() => this.recalcSentenceFrameDimensions(), 1);
			});

			observer.observe(this.$el, {
				attributes: false,
				childList: true,
				subtree: true
			});

			this.observer = observer;
			optimizedResize.add(this.recalcSentenceFrameDimensions);
		},
		beforeDestroy() {
			this.observer.disconnect();
			optimizedResize.remove(this.recalcSentenceFrameDimensions);
		},
		watch: {
			show: {
				handler: 'recalcSentenceFrameDimensions',
				immediate: true
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.sentence-frame {
		.sentence-frame-top,
		.sentence-frame-bottom {
			position: absolute;
			background-color: #000;
			opacity: 0.7;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			z-index: 2;
		}
	}
</style>
<template>
	<div
		class="sentence-frame"
		@mousemove="sentenceFrameTracking">
		<div
			class="sentence-frame-top"
			ref="frameTop"
			v-if="show"></div>
		<slot></slot>
		<div
			class="sentence-frame-bottom"
			ref="frameBottom"
			v-if="show"></div>
	</div>
</template>
